import React, { useState, useEffect } from "react";
import UserScreenWindow from "../Components/UserScreenWindow";
import { FiAlertTriangle, FiClock, FiHome } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { hoaLabel } from "../../../utils/constants";

function ErrorNoticePage() {
  const [countdown, setCountdown] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    if (countdown <= 0) {
      navigate("/login");
      return;
    }

    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown, navigate]);

  return (
    <UserScreenWindow label="Error">
      <div className="p-6 max-w-md mx-auto">
        <div className="flex flex-col items-center space-y-6">
          <div className="bg-[#363062]/10 p-4 rounded-full">
            <FiAlertTriangle className="text-[#363062] text-lg" />
          </div>

          <h2 className="text-lg font-semibold text-[#363062]">
            Account Error
          </h2>

          <p className="text-sm text-center text-gray-600">
            {`Your account has encountered an error. Please contact ${hoaLabel}
            Management to resolve the issue.`}
          </p>

          <div className="w-full bg-gray-100 rounded-full h-1.5">
            <div
              className="bg-[#8FCD00] h-1.5 rounded-full"
              style={{ width: `${(countdown / 5) * 100}%` }}
            ></div>
          </div>

          <div className="flex items-center text-sm text-gray-500">
            <FiClock className="mr-2" />
            <span>Redirecting to home in {countdown} seconds</span>
          </div>

          <button
            onClick={() => navigate("/")}
            className="flex items-center px-4 py-2 text-sm rounded bg-[#363062] text-white hover:bg-[#363062]/90 transition-colors"
          >
            <FiHome className="mr-2" />
            Go to Login
          </button>
        </div>
      </div>
    </UserScreenWindow>
  );
}

export default ErrorNoticePage;
